import { render } from "./FighterView.vue?vue&type=template&id=5c4ebe82&scoped=true"
import script from "./FighterView.vue?vue&type=script&lang=js"
export * from "./FighterView.vue?vue&type=script&lang=js"

import "./FighterView.vue?vue&type=style&index=0&id=5c4ebe82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4ebe82"]])

export default __exports__